const Pagination = props => {
  const pager = props.pager;
  const isFirstPage = pager.currentPage === 1;
  const isLastPage = pager.currentPage === pager.totalPages;
  return (
    <div className="pagination col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <button type="button" className={`btn btn-link ${isFirstPage? 'disabled': ''}`} onClick={() => (!isFirstPage && props.setPage(pager.currentPage - 1))}>
        <span className="fa fa-arrow-circle-left"></span>
      </button>
      <span className="pagination-text">{pager.currentPage} de {pager.totalPages} pag</span>
      <button type="button" className={`btn btn-link ${isLastPage? 'disabled': ''}`} onClick={() => (!isLastPage && props.setPage(pager.currentPage + 1))}>
        <span className="fa fa-arrow-circle-right"></span>
      </button>
    </div>
  )
}

export default Pagination;
